'use client';

import React from 'react';
import { VStack, HStack, Text, Box, LucideIcon, type LucideIconName } from '@skin-seoul/design-system';
import { DeliveryTrackingStatus, type TrackingEvent } from '@skin-seoul/service';

interface TrackingTimelineProps {
  events: TrackingEvent[];
}

const DEFAULT_ICON_NAME: LucideIconName = 'CircleCheck';

const TRACKING_STATUS_ICONS: Record<DeliveryTrackingStatus, LucideIconName> = {
  [DeliveryTrackingStatus.Delivered]: 'CircleCheck',
  [DeliveryTrackingStatus.CustomsCleared]: 'CircleCheck',
  [DeliveryTrackingStatus.InCustoms]: 'Circle',
  [DeliveryTrackingStatus.ArrivedDestination]: 'Globe',
  [DeliveryTrackingStatus.Departed]: 'Plane',
  [DeliveryTrackingStatus.InvoiceIssued]: 'Box',
};

export const TrackingTimeline = ({ events }: TrackingTimelineProps) => {
  return (
    <VStack gap={4} width="100%" alignItems="flex-start">
      {events.map((event) => {
        const iconName = TRACKING_STATUS_ICONS[event.type] ?? DEFAULT_ICON_NAME;
        const iconColor = event.status === 'completed' ? 'success.600' : 'neutral.700';

        return (
          <React.Fragment key={event.id}>
            <HStack gap={4} width="100%" alignItems="flex-start">
              <Box width={5} height={5} borderRadius="50%" flexShrink={0} color={iconColor}>
                <LucideIcon name={iconName} width={5} height={5} />
              </Box>

              <VStack gap={1} flex="1" alignItems="flex-start">
                <Text textStyle="label.small" fontWeight="medium" color="neutral.700">
                  {event.title}
                </Text>
                <Text textStyle="label.small" fontWeight="regular" color="neutral.400">
                  {event.timestamp}
                </Text>
              </VStack>
            </HStack>
          </React.Fragment>
        );
      })}
    </VStack>
  );
};
